export default __webpack_public_path__ + "static/media/cp_geo_na.e335bb35.svg";